// extracted by mini-css-extract-plugin
module.exports = {"arrowWrapper":"Pagination_arrowWrapper__LDOfn","prev":"Pagination_prev__FuZLM","next":"Pagination_next__Q1u2D"};